// extracted by mini-css-extract-plugin
module.exports = {"Margin":"Margin--3lgNq","MarginLarge":"MarginLarge--3tR7h"};